var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('PageIntro',{attrs:{"heading":'Resend Verification Link',"body":'<p>Please enter your email and we\'ll send you a new verfication link.</p>'}}),_c('SendConfirmCodeForm'),_c('FooterShout',{attrs:{"type":'register'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }